import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as OwnerService from '@/services/OwnerService';
import type { Owner } from '@/types/company';

export const useCreateOwner = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      companyId,
      data,
    }: {
      companyId: string;
      data: Omit<Owner, 'id' | 'companyId'>;
    }) => OwnerService.createOwner(companyId, data),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['companies', companyId] });
    },
  });
};

export const useUpdateOwner = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      companyId,
      ownerId,
      data,
    }: {
      companyId: string;
      ownerId: string;
      data: Partial<Omit<Owner, 'id' | 'companyId'>>;
    }) => OwnerService.updateOwner(companyId, ownerId, data),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['companies', companyId] });
    },
  });
};

export const useDeleteOwner = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, ownerId }: { companyId: string; ownerId: string }) =>
      OwnerService.deleteOwner(companyId, ownerId),
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['companies', companyId] });
    },
  });
};
